type Slice = {
  label: string;
  value: number;
  color: string;
};

const data: Slice[] = [
  { label: "Undeployed", value: 2_500_000, color: "#0F5D7F" },
  { label: "Deployed", value: 500_000, color: "#F97316" },
];

const radius = 60;
const strokeWidth = 24;
const circumference = 2 * Math.PI * radius;
const center = 100; // SVG center
const START_ANGLE = -Math.PI / 2;

const InvestmentPoolChart = () => {
  const total = data.reduce((sum, d) => sum + d.value, 0);

  let cumulativeAngle = 0;
  let angleCursor = 0;

  const GAP = 2;

  return (
    <div className="w-[300px] space-y-6">
      {/* Chart */}
      <div className="relative h-[300px] w-full flex items-center justify-center">
        <svg viewBox="0 0 200 200" className="h-full">
          <g transform="rotate(-90 100 100)">
            {data.map((slice) => {
              const fraction = slice.value / total;
              const dash = fraction * circumference - GAP;
              const offset = cumulativeAngle * circumference;

              cumulativeAngle += fraction;

              return (
                <circle
                  key={slice.label}
                  cx={center}
                  cy={center}
                  r={radius}
                  fill="none"
                  stroke={slice.color}
                  strokeWidth={strokeWidth}
                  strokeDasharray={`${dash} ${circumference}`}
                  strokeDashoffset={-offset}
                />
              );
            })}
          </g>

          {/* Connectors + labels */}
          {data.map((slice) => {
            const fraction = slice.value / total;
            const sliceAngle = fraction * Math.PI * 2;
            const midAngle = START_ANGLE + angleCursor + sliceAngle / 2;
            angleCursor += sliceAngle;

            const cos = Math.cos(midAngle);
            const sin = Math.sin(midAngle);

            const x1 = center + radius * cos;
            const y1 = center + radius * sin;
            const x2 = center + (radius + 20) * cos;
            const y2 = center + (radius + 20) * sin;
            const xText = center + (radius + 28) * cos;
            const yText = center + (radius + 28) * sin;

            return (
              <g key={slice.label} className="animate-label-in">
                <line
                  x1={x1}
                  y1={y1}
                  x2={x2}
                  y2={y2}
                  stroke="#9CA3AF"
                  strokeWidth="1"
                />
                <text
                  x={xText}
                  y={yText}
                  textAnchor={cos >= 0 ? "start" : "end"}
                  dominantBaseline="middle"
                  className="text-[11px] fill-gray-600"
                >
                  {slice.value.toLocaleString()}
                </text>
              </g>
            );
          })}
        </svg>
      </div>

      {/* Legend (bottom) */}
      <div className="flex justify-center gap-6">
        {data.map((item) => (
          <div key={item.label} className="flex items-center gap-2">
            <span
              className="h-3 w-3 rounded-sm"
              style={{ backgroundColor: item.color }}
            />
            <span className="text-sm text-gray-700">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InvestmentPoolChart;
